import { motion } from "framer-motion";
import { Factory, Airplane, Storefront, ShoppingBag, Code, Megaphone, Truck, FirstAid, Wrench } from "@phosphor-icons/react";

const items = [
  { icon: Factory, label: "Manufacturing" },
  { icon: Airplane, label: "Export" },
  { icon: Storefront, label: "Wholesale" },
  { icon: ShoppingBag, label: "Retail" },
  { icon: Code, label: "IT Services" },
  { icon: Megaphone, label: "Marketing Agencies" },
  { icon: Truck, label: "Logistics" },
  { icon: FirstAid, label: "Healthcare" },
  { icon: Wrench, label: "Construction" },
];

export default function WhoItsFor() {
  return (
    <section id="who" data-testid="who-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-xs font-bold uppercase tracking-[0.28em] text-emerald-700 mb-3">Who It&apos;s For</p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900">
            Built for the businesses that keep India moving.
          </h2>
          <p className="mt-4 text-slate-600 text-lg leading-relaxed">
            Whether you&apos;re shipping to enterprise buyers, exporting overseas, or running a growing service firm — Invoquity is designed for you.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {items.map((it, i) => (
            <motion.div
              key={it.label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: i * 0.04 }}
              data-testid={`industry-card-${i}`}
              className="group flex items-center gap-4 rounded-2xl bg-slate-50/70 border border-slate-100 p-5 hover:bg-emerald-50/50 hover:border-emerald-200 transition-all"
            >
              <div className="grid place-items-center w-12 h-12 rounded-xl bg-white border border-slate-200 text-emerald-700 group-hover:border-emerald-300">
                <it.icon size={22} weight="duotone" />
              </div>
              <span className="font-display text-base md:text-lg font-medium text-slate-800">{it.label}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
